var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "login",
    on: {
      click: function ($event) {
        _vm.useAuthV2 ? _vm.loginByAuthV2() : _vm.onFBLogin()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }